import type { UserInfo } from '@/modules/login/store/userInfo';
import { digitsEnToFa } from '@persian-tools/persian-tools';
import type { DabbehPatient } from '../types';

/** «زهرا محمدی». */
export const personName = (person?: Pick<UserInfo, 'name' | 'family'> | null) => [person?.name, person?.family].filter(Boolean).join(' ').trim();

/** «۰۰۱۲۳۴۵۶۷۸» — the whole code, in Persian digits (the owner asked for it unmasked). */
export const faNationalCode = (code?: string | null) => (code ? digitsEnToFa(String(code)) : '');

/** What a seat keeps of the person: the id the booking needs and the name the cards show. */
export const toPatient = (person: UserInfo): DabbehPatient => ({ id: String(person.id), name: personName(person) || null });
